import { combineReducers } from 'redux'

import Dashboard from '../reducer/dashboard/Reducer'
import AddToCart from './cart/Cart'

export default combineReducers({
    dashboard: Dashboard,
    AddToCart:AddToCart
   
})
